export default {"src":"/_next/static/media/trazado-mustard.24a477ff.svg","height":44,"width":206,"blurWidth":0,"blurHeight":0};